export default "__VITE_ASSET__B3Y57Ygx__"